var core = module.exports = { version: '2.6.4' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ./~/react-app-polyfill/~/core-js/modules/_core.js
// module id = 304
// module chunks = 0